// extracted by mini-css-extract-plugin
export default {"crossButton":"EmailVerifyModal_crossButton__Ptd5q","modal":"EmailVerifyModal_modal__wNX7q"};